import React from 'react'
import { isEmpty } from 'libraries/lodash'
import cx from 'classnames'
import produce from 'immer'
import { merge } from 'rxjs'
import { skipWhile, map } from 'rxjs/operators'
import { Keyboard } from 'front-end-core/services/WindowService'
import { dismissPopover, hideOverlay, OverlayItems } from 'services/OverlayService'
import Icon from 'components/shared/Icon'
import useBaseState from 'hooks/useBaseState'

/* TODO: investigate this component, is it obsolete ? OverlayService suggests that it requires an
    element with an id of '#application-content', but this has been removed.. */
const HelpOverlay = () => {
  const state = merge(
    OverlayItems,
    Keyboard.pipe(skipWhile(() => items.length === 0), map(key => handleKeypress(key)))
  )
  const { baseState: { items, show }, setBaseState } = useBaseState(
    state,
    { items: [], show: 0 }
  )

  const handleKeypress = (key) => {
    const current = show
    const count = items.length

    switch (key) {
      case 37:
      case 38:
        return { show: (current - 1 + count) % count }
      case 39:
      case 40:
        return { show: (current + 1) % count }
      case 27:
        hideOverlay()
    }
    return {}
  }

  if (isEmpty(items)) return null

  return (
    <div
      className='help-overlay'
      onClick={e => {
        dismissPopover(e.target)
        e.stopPropagation()
      }}
    >
      {items.map((item, key) => (
        <HelpItem
          key={key}
          {...item}
          show={show === key}
          onSelect={() => setBaseState(prevState => produce(prevState, draft => { draft.show = key }))}
        />
      ))}
      <a onClick={hideOverlay} href={null} className='pointer help-close'><Icon name='icon-close' /></a>
      <Cycler
        current={show}
        count={items.length}
        onSelect={(show) => produce(prevState => produce(prevState, draft => { draft.show = show }))}
      />
    </div>
  )
}

export default HelpOverlay

const HelpItem = ({ height, item, left, onSelect, position, show: active, top, width }) => (
  <div
    className={cx(`help-item ${position}`, { active })}
    style={{ height, left, top, width }}
    onClick={e => {
      dismissPopover(e.target)
      e.stopPropagation()
    }}
    onMouseMove={onSelect}
  >
    <div className='help-item-description' dangerouslySetInnerHTML={{ __html: item }} />
    <div className='help-item-border' />
  </div>
)

const Cycler = ({ current, count, onSelect }) => (
  <div
    className='help-cycler'
    onClick={e => {
      dismissPopover(e.target)
      e.stopPropagation()
    }}
  >
    <a href={null} className='pointer' onClick={() => onSelect((current - 1 + count) % count)}><Icon name='icon-chevron-left' /></a>
    {current + 1} / {count}
    <a href={null} className='pointer' onClick={() => onSelect((current + 1) % count)}><Icon name='icon-chevron-right' /></a>
  </div>
)
